import { render, staticRenderFns } from "./PanelNoveltyBox.vue?vue&type=template&id=421bf06e&scoped=true&"
var script = {}
import style0 from "./PanelNoveltyBox.vue?vue&type=style&index=0&id=421bf06e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421bf06e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('421bf06e')) {
      api.createRecord('421bf06e', component.options)
    } else {
      api.reload('421bf06e', component.options)
    }
    module.hot.accept("./PanelNoveltyBox.vue?vue&type=template&id=421bf06e&scoped=true&", function () {
      api.rerender('421bf06e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelNoveltyBox.vue"
export default component.exports